<template>
  <div class="business">
    <menuBox :step="2"></menuBox>
    <div class="about-title">
      <img class="left" src="../assets/left.png" alt="" />
      <div class="title">
        เป้าหมาย
      </div>
      <img class="right" src="../assets/right.png" alt="" />
      <!-- <p>
        In today's increasingly globalized economy, every enterprise on Earth is not an isolated entity; they are all global corporate citizens.
      </p> -->
    </div>
    <div class="business-box">
      <div class="b-title">เป้าหมายของพวกเรา</div>
      <div class="b-subtitle">
        บริษัทมุ่งมั่นที่จะเป็นผู้นำด้านนวัตกรรมทางการเงินและมีส่วนร่วมในความเป็นอยู่และการพัฒนาของชุมชนผ่านการมีส่วนร่วมทางสังคมอย่างแข็งขัน
      </div>
      <div class="business-img-text">
        <img src="../assets/mission-2.png" />
        <div class="text text-l">
          <p>
            <img src="../assets/mission-3.png" alt="" />
            การพัฒนาบริษัท 
            มาเป็นผู้นำด้านนวัตกรรมในด้านการเงิน เพิ่มประสิทธิภาพบริการอย่างต่อเนื่อง ขยายส่วนแบ่งการตลาด และบรรลุการเติบโตที่ยั่งยืน
          </p>
          <p>
            <img src="../assets/mission-3.png" alt="" />
            สวัสดิการสังคม 
            ด้วยการเข้าร่วมกิจกรรมสวัสดิการสาธารณะและโครงการความรับผิดชอบต่อสังคม เราจะนำผลกระทบเชิงบวกมาสู่ชุมชนและส่งเสริมการพัฒนาโดยรวมของสังคม
          </p>
        </div>
      </div>
    </div>
    <div class="business-partner">
      <div class="b-title">พันธมิตรทางธุรกิจของเรา</div>
      <div class="b-subtitle">
        จับมือกันให้เราเติบโตต่อไป
      </div>
      <div class="partner-list">
        <img src="../assets/icon-1.png" alt="">
        <img src="../assets/icon-2.png" alt="">
        <img src="../assets/icon-3.png" alt="">
        <img src="../assets/icon-4.png" alt="">
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.about-title {
  background-image: url(../assets/about-1.png);
  width: 100%;
  height: 400px;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    font-size: 64px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  img {
    width: 40px;
    height: 40px;
  }
  .left {
    margin-bottom: 50px;
    margin-right: 20px;
  }
  .right {
    margin-top: 50px;
    margin-left: 20px;
  }
  p {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}

.business-text {
  padding: 80px 360px 120px 360px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;

  p {
    text-indent: 2em;
    margin-top: 28px;
  }
}

.business-box {
  padding: 0px 360px;
  .b-title {
    margin-top: 120px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    text-align: center;
    color: #45289f;
  }
  .b-subtitle {
    font-size: 22px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    margin-bottom: 90px;
    text-align: center;
  }
  .business-img-text {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 120px;

    img {
      width: 560px;
    }

    .text {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-left:50px ;
      P:first-child{
        margin-bottom: 60px;
      }
      p {
        width: 474px;
        padding: 30px 50px;
        padding-top: 60px;
        height: 130px;
        box-shadow: 2px 2px 20px 5px rgba(209, 209, 234, 0.3);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        position: relative;
        img{
          width: 88px;
          height: 88px;
          position: absolute;
          top: -38px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
}
.business-partner{
  padding: 0px 360px;
  padding-bottom: 100px;
  .b-title {
    margin-top: 120px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    text-align: center;
    color: #45289f;
  }
  .b-subtitle {
    font-size: 22px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    margin-bottom: 90px;
    text-align: center;
  }
  .partner-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    img{
      width: 280px;
      /* height: 123px; */
      margin-bottom: 20px;
    }
  }
}
.statr-box {
  background: #b043fc;
  padding: 42px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .s-text {
    color: #fff;

    .text-1 {
      font-size: 40px;
      font-weight: 400;
      color: #ffffff;
    }

    .text-2 {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .btn {
    cursor: pointer;
    width: 160px;
    height: 64px;
    background: #ffffff;
    border-radius: 8px;
    line-height: 64px;
    font-size: 24px;
    text-align: center;
    font-weight: 400;
    color: #b043fc;
  }
}
</style>
